// 封装axios
import axios from 'axios'
import router from '../router'
import store from '../store'
const service = axios.create({
  // 设置携带Cookie
  withCredentials: true,
  // 默认超时设置
  // timeout: 60000,
  // 相对路径设置
  baseURL: ''
})

// http request
// // 添加请求拦截器
service.interceptors.request.use(config => {
  let token = 'C0NNqtiOd2BWElrR8W4l8c2t5O1NaX0D2c7cgGfFAyYykYTtgh6KUJTwA8WBSBkd'
  config.headers.common['Token'] = token
  return config
}, err => {
  router.push('/login')
  return Promise.reject(err)
})
// 添加响应拦截器
service.interceptors.response.use(
  function (response) {
    return response
  },
  function (error) {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          store.commit('del_token')
          router.push('/login')
      }
    }
    return Promise.reject(error)
  }
)
export default service



// WEBPACK FOOTER //
// ./src/request/http.js